require('./score-card.jade')
_ = require("lodash")

ScoreCardDirective = ($filter, AppSettingAPIService, ScoreCardUtilityService, $routeParams)->
  restrict: "A"
  replace: false
  templateUrl: "components/score-card/score-card.jade"
  scope:
    boardType: '@boardType'
    editMode: '='
    course: '=scoreCardCourse'
    tee: '=scoreCardTee'
    holes: '=scoreCardHoles'
    players: '=scoreCardPlayers'
    updateScores: '&onScoresUpdated'
  link: (scope) ->
    params =
      user_id: $routeParams.user_id
    AppSettingAPIService.getAppSetting(params).then (res)->
      scope.isUsingMeter = res.use_meter

    scope.getTotal = (key) ->
      _.chain scope.holes
        .map (s) -> s[key] || 0
        .reduce (sum, val) -> sum + val
        .value()

    scope.showHoleDistance = (holeYard) ->
      return "-" unless holeYard
      if scope.isUsingMeter
        $filter("number") ScoreCardUtilityService.yardToMeter(holeYard), 0
      else
        $filter("number") holeYard

    scope.boardTypeTitle = switch scope.boardType
      when 'in' then $filter("translate")("_SCORE_CARD_BOARD.IN")
      when 'out' then $filter("translate")("_SCORE_CARD_BOARD.OUT")
      when 'extra' then $filter("translate")("_SCORE_CARD_BOARD.EXTRA")
      else ''

    scope.$watch (-> scope.players), ->
      if scope.updateScores()
        scope.updateScores()(scope.players, scope.boardType)
    , true #true for watch deep in object

ScoreCardDirective.$inject = [
  "$filter"
  "AppSettingAPIService"
  "ScoreCardUtilityService"
  "$routeParams"
]

module.exports = ScoreCardDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/score-card-directive.coffee